import React, { useEffect, useState } from 'react';
import recommended from '../../images/recommended.svg'
import { Link,Navigate,useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

function RecommendBody(props) {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const theBusinessId = queryParams.get('businessId');
    const theCatId = queryParams.get('catId');
    const theEmail = queryParams.get('emailAddress');
    if(!token || !theBusinessId){
      window.location.href=''
    }

    const [questions, setQuestions] = useState([
        "You are tasked with designing the user interface for a new e-commerce website. What are the key steps in creating wireframes and prototypes for the website?",
        "How would you evaluate the usability of a given interface design?",
        "What are the challenges you might face in designing an intuitive navigation structure?",
        "What techniques would you use to ensure accessibility for all users?",
        "How do you prioritize features while designing the interface?",
    ])

    const [survey1, setSurvey1] = useState()
    const [survey2, setSurvey2] = useState()
    const [survey3, setSurvey3] = useState()
    const [survey4, setSurvey4] = useState()
    const [survey5, setSurvey5] = useState()

    const [survey1Ans, setSurvey1Ans] = useState()
    const [survey2Ans, setSurvey2Ans] = useState()
    const [survey3Ans, setSurvey3Ans] = useState()
    const [survey4Ans, setSurvey4Ans] = useState()
    const [survey5Ans, setSurvey5Ans] = useState()

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [ratings, setRatings] = useState(Array(questions.length).fill(null));
    const [showSuccess, setShowSuccess] = useState(false);

    const handleRating = (rating) => {
        const updatedRatings = [...ratings];
        updatedRatings[currentQuestionIndex] = rating;
        setRatings(updatedRatings);
        if(currentQuestionIndex+1 == 1){
          if(survey1){
            setSurvey1Ans(rating)
          }
        }
        if(currentQuestionIndex+1 == 2){
          if(survey2){
            setSurvey2Ans(rating)
          }
        }
        if(currentQuestionIndex+1 == 3){
          if(survey3){
            setSurvey3Ans(rating)
          }
        }
        if(currentQuestionIndex+1 == 4){
          if(survey4){
            setSurvey4Ans(rating)
          }
        }
        if(currentQuestionIndex+1 == 5){
          if(survey5){
            setSurvey5Ans(rating)
          }
        }
        InputAnswers('question'+(currentQuestionIndex+1),rating)
    };

    const handleNext = () => {

        if (currentQuestionIndex < questions.length - 1) {
          setCurrentQuestionIndex(currentQuestionIndex + 1);
        } else {
          submitSurvey()
        }
    };

    function GoHome(){
        window.location.href="/"
    }

    const [answers, setAnswers] = useState([])

    const InputAnswers = (field,value) => {
      setAnswers({...answers,[field] : value})
    }

    function generateFingerprint() {
      return uuidv4();
    }

    function Platform () {
      if (navigator.userAgentData) {
        return navigator.userAgentData.platform
      } else {
        return null
      }
    }
    const [surveyResponse, setSurveyResponse] = useState({emailAddress:theEmail,isRecommended:true,token:token,businessProfileId:theBusinessId,ipAddress:'0.0.0.0',fingerPrint:generateFingerprint(),platform:Platform(),latitude:0,longitude:0})



    const [checked, setChecked] = useState(false);
    const [surveyData, setSurveyData] = useState([])
    const navigate = useNavigate();
    useEffect(() => {
      if(!checked){
        if (!queryParams.has("token") || !queryParams.has("businessId") || !queryParams.has("catId")) {
          navigate("/", { replace: true }); 
        }
        setChecked(true);
      }
      axios.get(process.env.REACT_APP_BASE_URL+'/Survey/GetCategory/'+theCatId,{})
      .then((res) => {
          if(res.status == 200){
            const parsedJson = JSON.parse(res.data.data.json);
            const arrayData = Object.entries(parsedJson);
            console.log(arrayData)
            setSurveyData(arrayData);
            InputAnswers('question6',arrayData[2][1])
            setQuestions((arrayData[6][1]).slice(0,5))
          }}
      ).then(() => {
         axios.get(process.env.REACT_APP_BASE_URL+'/Survey/GetSurvey/'+theBusinessId,{})
         .then((res) => {
          if(res.status == 200){
           setSurvey1(res.data.data.survey1)
           setSurvey2(res.data.data.survey2)
           setSurvey3(res.data.data.survey3)
           setSurvey4(res.data.data.survey4)
           setSurvey5(res.data.data.survey5)
          }})
      })
      .catch((e) => {
          console.log(e)
      })
    }, [checked,location,navigate])

    const [processing, setProcessing] = useState(0)
    const submitSurvey = () => {
      surveyResponse.surveyData = JSON.stringify(answers)
      if(survey1) surveyResponse.survey1 = survey1Ans.toString();
      if(survey2) surveyResponse.survey2 = survey2Ans.toString();
      if(survey3) surveyResponse.survey3 = survey3Ans.toString();
      if(survey4) surveyResponse.survey4 = survey4Ans.toString();
      if(survey5) surveyResponse.survey5 = survey5Ans.toString();
      setProcessing(1)
      axios.post(process.env.REACT_APP_BASE_URL+'/Recommendation/Create',surveyResponse,{})
      .then((res) => {
          if(res.data.data.isSuccess){
              setProcessing(0)
              setShowSuccess(true)
          }else{
            alert('Invalid token, please begin the recommendation again')
          }
        }
      )
      .catch((e) => {
          console.log(e)
      })
    }
    return (
    <div>
    {showSuccess ? 
      <div tabIndex="-1" aria-hidden="true" className='fixed top-0 left-0 right-0 h-screen bg-black bg-opacity-50 inset-0 items-center justify-center z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full'>
        <div className="relative w-[90%] lg:w-[40%] mt-[10%] lg:mt-[5%] max-h-full mx-auto">
          <div className="relative bg-white shadow pt-3 rounded-[8px] py-10">
            <div className='mx-auto flex flex-col px-10 space-y-4'>
              <span className=''><img className='mx-auto' src={recommended} /></span>
                <h1 className="text-[20px] font-[500] text-[#121212">
                Recommended!
              </h1>
              <span className='text-[16px] font-[400] text-[#737373] mb-3'>You have successfully recommended <span className='text-[#0E0E0E]'>{sessionStorage.getItem('businessName')}.</span> Thank you for your time.</span>
              <Link to='/' type='button' onClick={GoHome}
                className={`w-full py-2 text-[14px] px-4 rounded-[24px] text-white font-[400] bg-[#008B39]`}
              >Go Home</Link>
            </div>

          </div> 
        </div>
      </div>
  :''
    }
    <div className={`flex flex-col items-center justify-center py-10 bg-gray-100 p-4`}>
      <div className="bg-white p-6 rounded shadow-md w-[90%] lg:w-[80%]">
          <>
            <p className="text-start text-[#979797] mb-4">
              Question {currentQuestionIndex + 1}
            </p>
            {currentQuestionIndex+1 == 1 ? 
            <p className="mb-6 text-start">
            {questions[currentQuestionIndex] ? (questions[currentQuestionIndex].elements ? 
              (survey1 ? survey1 :questions[currentQuestionIndex].elements[0].title)
              : '') 
              : ''
              }
            </p>
            : ''}

            {currentQuestionIndex+1 == 2 ? 
            <p className="mb-6 text-start">
            {questions[currentQuestionIndex] ? (questions[currentQuestionIndex].elements ? 
              (survey2 ? survey2 :questions[currentQuestionIndex].elements[0].title)
              : '') 
              : ''
              }
            </p>
            : ''}

            {currentQuestionIndex+1 == 3 ? 
            <p className="mb-6 text-start">
            {questions[currentQuestionIndex] ? (questions[currentQuestionIndex].elements ? 
              (survey3 ? survey3 :questions[currentQuestionIndex].elements[0].title)
              : '') 
              : ''
              }
            </p>
            : ''}

            {currentQuestionIndex+1 == 4 ? 
            <p className="mb-6 text-start">
            {questions[currentQuestionIndex] ? (questions[currentQuestionIndex].elements ? 
              (survey4 ? survey4 :questions[currentQuestionIndex].elements[0].title)
              : '') 
              : ''
              }
            </p>
            : ''}

            {currentQuestionIndex+1 == 5 ? 
            <p className="mb-6 text-start">
            {questions[currentQuestionIndex] ? (questions[currentQuestionIndex].elements ? 
              (survey5 ? survey5 :questions[currentQuestionIndex].elements[0].title)
              : '') 
              : ''
              }
            </p>
            : ''}
            <div className="flex justify-start space-x-4 mb-6">
              {[1, 2, 3, 4, 5].map((rating) => (
                <button
                  key={rating}
                  className={`w-10 h-10 rounded-full border  font-medium ${
                    ratings[currentQuestionIndex] === rating
                      ? "bg-[#008B39] text-white"
                      : "bg-[#F3F3F3]"
                  }`}
                  onClick={() => handleRating(rating)}
                >
                  {rating}
                </button>
              ))}
            </div>
            <div className='grid grid-cols-5 mt-20 mb-5'>
              {questions.map(({},id) => {
                return (
                  <span><hr className={`${(id+1 <= currentQuestionIndex +1) ? 'border-[#008B39]' : ''}`}/></span>
                )
              })}
            </div>
            <div className='flex flex-row justify-between items-center'>
              <span>{currentQuestionIndex+1}/{questions.length}</span>
              <button
              onClick={handleNext}
              disabled={ratings[currentQuestionIndex] === null}
              className={`w-[120px] py-2 px-4 rounded text-white font-semibold ${
                ratings[currentQuestionIndex] === null
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-[#008B39] hover:bg-[#008B39]"
              }`}
            >
              {currentQuestionIndex === questions.length - 1
                ? "Finish"
                : "Continue"}
            </button>
            </div>
          </>
      </div>
    </div>
        </div>
    );
}

export default RecommendBody;